import { render, staticRenderFns } from "./CreateSubCategory.vue?vue&type=template&id=295b6a05&scoped=true"
import script from "./CreateSubCategory.vue?vue&type=script&lang=js"
export * from "./CreateSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b6a05",
  null
  
)

export default component.exports